/**
 * This event hook is useful for any scenario where it's needed to
 * have callback alike behavior.
 *
 * A special scenario is when using async/await invocations within
 * composition APIs that returns refs. In this way you don't need to
 * await in the Vue's setup() lifecycle, once it cannot be async.
 *
 * However, with an event hook you can still react to the event that
 * is triggered by the async/await resolution.
 *
 * For usage examples, see the implementation on useQuery and useMutation.
 */
export default function useEventHook() {
  const callbacks = [];

  function on(fn) {
    callbacks.push(fn);
    return {
      off: () => off(fn),
    };
  }

  function off(fn) {
    const index = callbacks.indexOf(fn);
    if (index !== -1) {
      callbacks.splice(index, 1);
    }
  }

  function trigger(param) {
    for (const callback of callbacks) {
      callback(param);
    }
  }

  return {
    on,
    off,
    trigger,
  };
}
